import { Link } from 'react-router-dom';
import { LineChart, PackageMinus, ArrowRight, ShieldAlert, ShoppingCart, Receipt, Truck, BarChart3 } from 'lucide-react';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';

// Add new analytics here – each becomes a tile on /analytika
export const ANALYTICS = [
  {
    id: 'vydeje-nes',
    path: '/analytika/vydeje-nes',
    title: 'Výdeje a Sklad NES',
    description: 'Výdejky řad 290/291, nejodepisovanější položky, pohyb a stav skladu NES',
    source: 'K2',
    icon: PackageMinus,
    color: '#16A34A',
  },
  {
    id: 'nakup',
    path: '/analytika/nakup',
    title: 'Nákup – příjemky',
    description: 'Nákup podle dodavatelů, nejnakupovanější zboží a vývoj nákupních cen',
    source: 'K2',
    icon: ShoppingCart,
    color: '#0EA5E9',
  },
  {
    id: 'faktury-prijate',
    path: '/analytika/faktury-prijate',
    title: 'Přijaté faktury',
    description: 'Fakturace podle dodavatelů, řady 100/110, neuhrazené faktury a faktury po splatnosti',
    source: 'K2',
    icon: Receipt,
    color: '#DC2626',
  },
  {
    id: 'spotreba',
    path: '/analytika/spotreba',
    title: 'Výdeje Expediční sklady',
    description: 'Výdeje řady 230 podle odběratelů a zboží, srovnání týdnů',
    source: 'K2',
    icon: Truck,
    color: '#8B5CF6',
  },
  {
    id: 'prehledy',
    path: '/prehledy',
    title: 'Přehledy (staré)',
    description: 'Původní dashboardy z importovaných Excelů – L1, nákupy, sklad, výroba, nutriční péče',
    source: 'Excel',
    icon: BarChart3,
    color: '#F59E0B',
  },
];

const Tile = ({ a, i }) => {
  const Icon = a.icon;
  return (
    <Link
      to={a.path}
      data-testid={`analytics-tile-${a.id}`}
      className="group relative bg-white border border-[#E2E8F0] rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 hover:border-[#86EFAC] transition-[transform,box-shadow,border-color] duration-200 animate-in fade-in slide-in-from-bottom-2"
      style={{ animationDelay: `${i * 60}ms`, animationFillMode: 'both' }}
    >
      <div className="flex items-start justify-between">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${a.color}1A` }}>
          <Icon className="w-6 h-6" style={{ color: a.color }} />
        </div>
        <span className="text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#F1F5F1] text-[#57534E]">{a.source}</span>
      </div>
      <h2 className="mt-4 text-lg font-bold text-[#052E16] font-['Manrope']">{a.title}</h2>
      <p className="mt-1 text-sm text-[#57534E] min-h-[40px]">{a.description}</p>
      <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#16A34A]">
        Otevřít <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
};

export default function AnalyticsHubPage() {
  const { canViewOverviews } = useAuth();
  return (
    <Layout>
      {!canViewOverviews ? (
        <div className="py-20 text-center" data-testid="analytics-no-access">
          <ShieldAlert className="w-14 h-14 text-[#E2E8F0] mx-auto mb-3" />
          <p className="text-[#57534E]">Nemáte oprávnění k zobrazení Analytiky.</p>
        </div>
      ) : (
        <div className="space-y-6" data-testid="analytics-hub">
          <div>
            <h1 className="text-3xl lg:text-4xl font-bold text-[#052E16] font-['Manrope'] flex items-center gap-3">
              <LineChart className="w-8 h-8 text-[#16A34A]" /> Analytika
            </h1>
            <p className="text-[#57534E] mt-1">Vyberte analýzu</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="analytics-tiles">
            {ANALYTICS.map((a, i) => <Tile key={a.id} a={a} i={i} />)}
          </div>
        </div>
      )}
    </Layout>
  );
}
